const calculateHandler = require('./clientPurchase-fullcont-calculate-handler')

//Para poner que no se pueda cambiar el item o eliminar si este tiene sale, solo permitir  cambiar sus propiedades 
//como la cantidad o la unidad etc.

//mostrar el mt de lost
export function showMtlost(htmlFc) {

  let showMtlost = htmlFc.fullcontHTML.querySelector("#showMtlost").checked;

  if (showMtlost) {
    let mt_lost = htmlFc.fullcontHTML.querySelector("#mt_lost");
    mt_lost.classList.remove('dn');

  } else {
    let mt_lost = htmlFc.fullcontHTML.querySelector("#mt_lost");
    mt_lost.classList.add('dn');

  }

  calculateHandler.calculate_total_lost_returned();

}

//mostrar la seccion de lost
export function showLost() {
  let lost = document.querySelector('#lost');
  lost.classList.remove('dn');

  EventClickShowHideMt(false)
}

//ocultar la seccion de lost
export function hideLost() {
  let lost = document.querySelector('#lost');
  lost.classList.add('dn');
}

export function EventClickShowHideMt(action) {
  let event = new Event('change');
  let showLostInput = document.querySelector('#showMtlost');
  showLostInput.checked = action;

  event = new Event('change');
  showLostInput.dispatchEvent(event);
}

//mostrar o ocultar la columna de qty return en el mt principal
// tambien los input de la columna total del mt principal se van a ocultar y se colocaran otro
// por encima de estos, para no afectar los originales, asi mismo con el input del total de la columna 
export function showReturnMtItem(show) {
  const returns = document.querySelectorAll("#clientPurchase-fullcont .showReturnMtItem");
  const totals = document.querySelectorAll("#clientPurchase-fullcont .showtotal");

  returns.forEach(element => element.classList.toggle("dn", !show));
  totals.forEach(element => element.classList.toggle("dn", show));
}